package com.exura.features.plandefinition.data.remote.dto.series

import com.exura.features.plandefinition.domain.model.series.HourOfDay
import com.exura.features.plandefinition.domain.model.series.PartOfDay
import com.exura.features.plandefinition.domain.model.series.SeriesSpawnType
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * DTO for SimpleInstructionSeries.
 * Extends BaseAnchoredSeriesDto for Firebase storage compatibility.
 */
@Serializable
@SerialName("instruction_series")
data class SimpleInstructionSeriesDto(
    override val name: String,
    override val description: String,
    override val seriesType: SeriesSpawnType = SeriesSpawnType.INSTRUCTION,
    override val durationInDays: Int? = null,
    val relativeDay: Int,
    val spawnForDays: Int? = null,
    val spawnCount: Int? = null,
    val instruction: String,
    val estimatedMinutes: Int,
    val partsOfDay: List<PartOfDay>? = null,
    val exactTimes: List<HourOfDay>? = null,
    override val imageUrl: String? = null,
    val spawnEveryDays: Int = 1,
) : BaseSeriesDto()
